import { CalculationType, QuotingType } from "../state/quote-reducer";
import { IQuoteHandler } from "./interfaces/IQuoteHandler";
import { RentalQuoteDetail } from "./models/quote.model";
import { RentalCalculation } from "./models/rental/rental-calculation.model";
import { RentalPremierQuote } from "./models/rental/rental.model";
import { RentalQuoteHandler } from "./RentalQuoteHandler";

export class RentalPremierQuoteHandler
  extends RentalQuoteHandler
  implements IQuoteHandler
{
  public formatQuoteForAction(
    quote: QuotingType,
    calculation: CalculationType,
    isCopy: boolean = false
  ): RentalQuoteDetail {
    if (isCopy && quote && calculation) {
      calculation.id = "";
      quote.sfaccountid = undefined;
      quote.sfdealid = undefined;
      quote.hasSubmittedQuote = false;
    }

    return new RentalQuoteDetail(
      quote as RentalPremierQuote,
      calculation as RentalCalculation
    );
  }
}
